import { TaskTypeId } from "@sp-crm/core";

export interface ActivityTypeFilterableItem {
    taskTypeId?: TaskTypeId | null;
}

export const filterActivityItemsByType = <T extends ActivityTypeFilterableItem>(
    items: T[],
    selected: TaskTypeId | null,
): T[] => {
    if (selected === null) {
        return items;
    }
    return items.filter(item => item.taskTypeId === selected);
};

export const toggleActivityTypeFilter = (
    selected: TaskTypeId | null,
    taskTypeId: TaskTypeId,
): TaskTypeId | null => (selected === taskTypeId ? null : taskTypeId);
